import { render, staticRenderFns } from "./addExpenseJurDialog.vue?vue&type=template&id=ba4ed522&scoped=true"
import script from "./addExpenseJurDialog.vue?vue&type=script&lang=js"
export * from "./addExpenseJurDialog.vue?vue&type=script&lang=js"
import style0 from "./addExpenseJurDialog.vue?vue&type=style&index=0&id=ba4ed522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4ed522",
  null
  
)

export default component.exports